
  import { Component, Watch } from 'vue-property-decorator'
  import GTextarea from '@/components/core/input/GTextarea.vue'
  import PTitle from '@/components/config/PTitle.vue'
  import { GenioView } from './GenioView'

@Component({
  components: { PTitle, GTextarea },
})
  export default class ConfigSale extends GenioView {
    formData = {
      warranty: {
        enabled: true,
        coverage: {
          list: [
            'Desperfectos o fallas en el motor.',
            'Desperfectos o fallas en la transmisión automática.',
            'Desperfectos o fallas en el sistema de aire acondicioando.',
          ],
          text: 'El vehículo está cubierto por la garantía postventa que protege contra:',
        },
        conditions: {
          list: [
            'La garantía es válida por un período de 90 días o 5.000 kilómetros, lo que ocurra primero, desde la entrega del vehículo.',
            'Las partes o repuestos serán reparados o reemplazados por nuevos, a discreción de nuestros técnicos calificados.',
            'Los reclamos deben hacerse dentro de las 24 horas de ocurrido el desperfecto para evitar daños mayores.',
            'El evento debe ser reportado antes del fin del período de cobertura de la garantía.',
            'La garantía es exigible presentando este certificado.',
          ],
        },
        exclusions: {
          list: [
            'Todos los componentes eléctricos y/o electrónicos del vehículo.',
            'Desperfectos por desgaste normal de uso o funcionamiento tales como:[nl]Lubricantes, Filtros, Afinamiento, Embrague, Sistema de frenos, Sistema de amortiguación, Refrigerantes, Plumillas, Neumáticos, Parabrisas o vidrios, Tapiz, Accesorios internos, Equipos de radio y sonido, Cierre centralizado, Alarma o alzavidrios, Dispositivos electrónicos o sensores',
          ],
        },
        expiration: {
          list: [
            'Si la mantención indicada por el fabricante no se realiza dentro del plazo o kilometraje indicado en el manual del vehículo.',
            'Si la mantención es realizada por cualquier persona o equipo distinto de servicios autorizados por la marca.',
            'Usar piezas no originales o adulterar de cualquier forma el equipamiento del vehículo.',
            'Participar en carreras de competición, rallies u otros.',
            'Choques, accidentes, abuso o negligencia.',
          ],
          text: 'La garantía expirará en los siguientes casos:',
          product_warranty: {
            mechanic: {
              text: 'Garantía mecánica',
              duration: {
                months: 3,
              },
            },
            air_conditioning: {
              text: 'Aire acondicionado',
              duration: {
                months: 3,
              },
            },
          },
        },
        considerations: {
          list: [
            'Los desgastes por uso no se consideran fallas.',
            'Los daños por uso tales como pinchazos, abollones o trizaduras, no se consideran fallas',
            'Las fallas provocadas por choque, golpes o uso negligente no están cubiertas.',
            'Los costos de mantenimiento son responsabilidad del cliente.',
            'Gastos indirectos como remolque, viáticos, comidas, alojamiento, peajes, daños a terceros, pérdida de tiempo, lucro cesante u otros perjuicios indirectos no están cubiertos por esta garantía.',
          ],
        },
        formWithoutWarranty: true,
      },
    }

    async save () {
      if (!this.$refs.form.validate()) {
        await this.setFieldError()
        return
      }

      const fields = {
        id: this.process.id,
        config: {
          ...this.process.config,
          warranty: this.formData.warranty,
        },
      }

      await this.updateProcess(fields)

      this.$emit('update')
    }

    addCoverage () {
      this.formData.warranty.coverage.list.push('')
    }

    removeCoverage (index: number) {
      this.formData.warranty.coverage.list.splice(index, 1)
    }

    addConditions () {
      this.formData.warranty.conditions.list.push('')
    }

    removeConditions (index: number) {
      this.formData.warranty.conditions.list.splice(index, 1)
    }

    addExclusions () {
      this.formData.warranty.exclusions.list.push('')
    }

    removeExclusions (index: number) {
      this.formData.warranty.exclusions.list.splice(index, 1)
    }

    addExpiration () {
      this.formData.warranty.expiration.list.push('')
    }

    removeExpiration (index: number) {
      this.formData.warranty.expiration.list.splice(index, 1)
    }

    addConsiderations () {
      this.formData.warranty.considerations.list.push('')
    }

    removeConsiderations (index: number) {
      this.formData.warranty.considerations.list.splice(index, 1)
    }

    @Watch('process', { immediate: true, deep: true })
    onConfigChange (newValue: any) {
      if (newValue?.config?.warranty) {
        this.formData.warranty = newValue.config.warranty
      }
    }
  }
